export const ContactTypeIdEnum = {
  lookupTypeId: 1211,
};
